import type { IconSvgObject } from './types';

const Watch01Icon: IconSvgObject = [
  ["circle", { cx: "12", cy: "12", r: "7", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 10V12.005L13 13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M16 6L15.1894 2.75746C15.0781 2.3123 14.6781 2 14.2192 2L9.78078 2C9.32191 2 8.92193 2.3123 8.81063 2.75747L8 6", stroke: "currentColor", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M16 18L15.1894 21.2425C15.0781 21.6877 14.6781 22 14.2192 22L9.78078 22C9.32191 22 8.92193 21.6877 8.81063 21.2425L8 18", stroke: "currentColor", strokeWidth: "1.5", key: "3" }]
];

export default Watch01Icon;
